import moment from "moment";

export const dateTimeConverter = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
